'use client'

import { UserButton } from '@daveyplate/better-auth-ui'
import { SiTelegram, SiYoutube } from '@icons-pack/react-simple-icons'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { TelegramLogin } from '~/components/auth/telegram-login'
import { Avatar } from '~/components/ui/catalyst/avatar'
import {
  Navbar,
  NavbarDivider,
  NavbarItem,
  NavbarLabel,
  NavbarSection,
  NavbarSpacer,
} from '~/components/ui/catalyst/navbar'
import {
  Sidebar,
  SidebarBody,
  SidebarHeader,
  SidebarItem,
  SidebarSection,
} from '~/components/ui/catalyst/sidebar'
import { StackedLayout } from '~/components/ui/catalyst/stacked-layout'
import { useSession } from '~/lib/auth.client'
import { isActive } from '~/lib/is-active'
import { getCdnPath } from '~/lib/utils'

const navItems = [
  { label: 'Шпаргалки Вадима', url: '/plus/questions' },
  { label: 'Примеры собесов', url: '/plus/interview-leaks' },
  { label: 'Видео', url: '/plus/videos' },
  // { label: 'База вопросов', url: '/questions' },
  // { label: 'Тренажер', url: '/events' },
  // { label: 'AI-интервью', url: '/orders' },
  // { label: 'Тестовые задания', url: '/broadcasts' },
  // { label: 'Лайвкодинг задачи', url: '/settings' },
]

interface ApplicationLayoutProps {
  children: React.ReactNode
}

export function ApplicationLayout(props: ApplicationLayoutProps) {
  const pathname = usePathname() ?? '/'
  const { data: session } = useSession()

  if (pathname.includes('embed')) {
    return props.children
  }

  return (
    <StackedLayout
      navbar={(
        <Navbar>
          <NavbarItem href="/">
            <Avatar
              alt="Логотип Карьерной платформы Вадима Новосёлова"
              className="size-6!"
              src={getCdnPath('/assets/vadim-novosolov.jpg')}
              square
            />
            <NavbarLabel>
              Карьерная платформа
            </NavbarLabel>
          </NavbarItem>
          <NavbarDivider className="max-lg:hidden" />
          <NavbarSection className="max-lg:hidden">
            {navItems.map(({ label, url }) => {
              const isCurrent = isActive(url, pathname)

              return (
                <NavbarItem key={label} href={url} current={isCurrent}>
                  {label}
                </NavbarItem>
              )
            })}
          </NavbarSection>
          <NavbarSpacer />
          {session?.user
            ? (
                <UserButton size="icon" />
              )
            : (
                <TelegramLogin
                  align="right"
                  onError={(error) => {
                    console.error('Login failed:', error)
                  }}
                />
              )}
        </Navbar>
      )}
      sidebar={(
        <Sidebar>
          <SidebarHeader>
            <SidebarItem>
              <Avatar
                alt="Логотип Карьерной платформы Вадима Новосёлова"
                className="size-9!"
                src={getCdnPath('/assets/vadim-novosolov.jpg')}
                square
              />
              <NavbarLabel>
                Карьерная платформа
                <br />
                Вадима Новосёлова
              </NavbarLabel>
            </SidebarItem>
          </SidebarHeader>
          <SidebarBody>
            <SidebarSection>
              {navItems.map(({ label, url }) => {
                const isCurrent = isActive(url, pathname)

                return (
                  <SidebarItem key={label} href={url} current={isCurrent}>
                    {label}
                  </SidebarItem>
                )
              })}
            </SidebarSection>
          </SidebarBody>
        </Sidebar>
      )}
      footer={(
        <div className="flex flex-col items-center justify-between gap-2 lg:flex-row">
          <p className="flex items-center justify-center space-x-1.5 text-sm font-medium text-gray-500">
            <span className="text-base">&copy;</span>
            <span>
              2023 —
              {new Date().getFullYear()}
            </span>
            <span>Вадим Новосёлов</span>
          </p>

          <div className="flex flex-wrap justify-center gap-4">
            <Link
              className="flex items-center gap-1.5 opacity-50 transition-opacity hover:opacity-100"
              href="https://www.youtube.com/@gernar228"
              rel="noopener noreferrer"
              target="_blank"
            >
              <SiYoutube color="#FF0000" size={18} />
              <span className="text-sm font-medium">Ютуб канал</span>
            </Link>

            <Link
              className="flex items-center gap-1.5 opacity-50 transition-opacity hover:opacity-100"
              href="https://t.me/gernar228"
              rel="noopener noreferrer"
              target="_blank"
            >
              <SiTelegram color="#26A5E4" size={18} />
              <span className="text-sm font-medium">Телеграм канал</span>
            </Link>
          </div>
        </div>
      )}
    >
      {pathname === '/' && (
        <div
          className="bg-image-hero pointer-events-none absolute inset-x-0 top-0 z-0 h-[1200px] w-full select-none"
          style={{ backgroundImage: `url(${getCdnPath('/home-hero-clouds.svg')})` }}
        />
      )}
      {props.children}
    </StackedLayout>
  )
}
